import { type ClassValue, clsx } from 'clsx';

/**
 * Utility function for merging class names
 * Similar to shadcn/ui's cn() function
 */
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}
